import React from 'react';
import { Link } from 'react-router-dom';
import { 
  Target, 
  Eye, 
  Lightbulb, 
  TrendingUp,
  Users,
  BookOpen,
  Globe,
  Network,
  Award,
  FileText,
  MessageSquare,
  GraduationCap,
  CheckCircle,
  ArrowRight
} from 'lucide-react';

const QuienesSomos = () => {
  const objetivos = [
    {
      titulo: 'Establecer y desarrollar proyectos de colaboración',
      descripcion: 'Participar y colaborar en iniciativas y actividades entre Cátedras UNESCO y redes UNITWIN en torno a la educación superior en Iberoamérica para apoyar y desarrollar la capacidad de acción orientada hacia la inclusión, integración y complementariedad de las iniciativas mediante intercambios, investigaciones, difusión de conocimiento, e internacionalización del conocimiento.',
      icon: Network
    },
    {
      titulo: 'Desarrollar publicaciones colectivas',
      descripcion: 'Difundir y apropiar la información especializada y uso de conocimiento mediante la investigación conjunta, comparada – local, regional, internacional- orientada hacia gestión de proyectos de investigación con calidad y la realización de publicaciones colectivas la transformación, desarrollo e internacionalización de las instituciones y los sistemas de educación superior.',
      icon: BookOpen
    },
    {
      titulo: 'Programa Postdoctoral en educación superior',
      descripcion: 'Desarrollar un Programa Postdoctoral en la educación superior para la formación de nuevas generaciones de investigadores, contribuir a elevar la capacidad de investigación, creación y difusión de conocimiento en la región.',
      icon: GraduationCap
    },
    {
      titulo: 'Creación de iniciativas y proyectos entre redes',
      descripcion: 'Fomentar la colaboración activa y el desarrollo de proyectos conjuntos que fortalezcan las redes de conocimiento en Iberoamérica.',
      icon: Lightbulb
    }
  ];

  const lineamientosAccion = [
    {
      titulo: 'Organización de eventos académicos',
      descripcion: 'Organizar y auspiciar foros, conferencias, simposios y publicaciones académicas para la discusión de resultados de proyectos de gestión de conocimiento, de las políticas de educación superior y de iniciativas de colaboración de las cátedras y redes de la UNESCO.',
      icon: MessageSquare
    },
    {
      titulo: 'Investigación conjunta y comparada',
      descripcion: 'Promover la investigación conjunta, comparada, en red y entre redes para fortalecer el desarrollo y transformaciones de las instituciones y ampliar la capacidad de cambio colaborativa para cumplir con su responsabilidad social.',
      icon: FileText
    },
    {
      titulo: 'Consolidación de redes de investigación',
      descripcion: 'Estimular la formación y consolidación de redes de investigación iberoamericanas mediante la gestión de proyectos de investigación con calidad y la realización de publicaciones colectivas, difundiendo y apropiando la información especializada y la posibilidad de formar parte de grupos internacionales en torno a los saberes requeridos para su práctica social buscando contribuir a la promoción y la renovación del pensamiento crítico.',
      icon: Network
    }
  ];

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-50 to-white">
      {/* Hero Section */}
      <div className="relative bg-gradient-to-r from-[#0077C8] via-[#005A9C] to-[#004B87] text-white py-20 overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PHBhdHRlcm4gaWQ9ImdyaWQiIHdpZHRoPSI2MCIgaGVpZ2h0PSI2MCIgcGF0dGVyblVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+PHBhdGggZD0iTSAxMCAwIEwgMCAwIDAgMTAiIGZpbGw9Im5vbmUiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS13aWR0aD0iMSIvPjwvcGF0dGVybj48L2RlZnM+PHJlY3Qgd2lkdGg9IjEwMCUiIGhlaWdodD0iMTAwJSIgZmlsbD0idXJsKCNncmlkKSIvPjwvc3ZnPg==')] opacity-20"></div>
        </div>
        
        <div className="relative max-w-7xl mx-auto px-6">
          {/* Logos Header */}
          <div className="bg-gradient-to-br from-white/95 to-white/90 rounded-2xl p-6 md:p-8 shadow-lg border border-white/30 mb-12 relative overflow-hidden backdrop-blur-sm">
            <div className="absolute inset-0 bg-gradient-to-r from-[#0077C8]/5 via-transparent to-[#0077C8]/5"></div>
            <div className="relative flex flex-col md:flex-row items-center justify-center gap-8 md:gap-10">
              {/* Logo Foro Iberoamericano */}
              <div className="group flex flex-col items-center">
                <div className="bg-white rounded-xl p-6 shadow-md hover:shadow-xl transition-all duration-300 transform group-hover:scale-105 border-2 border-transparent hover:border-[#0077C8]/20">
                  <img 
                    src="https://catedra-unesco.cenid.org/images/logo_foro.jpg" 
                    alt="Logo Foro Iberoamericano" 
                    className="h-24 md:h-32 w-auto object-contain"
                  />
                </div>
                <span className="mt-3 text-sm font-semibold text-gray-700 group-hover:text-[#0077C8] transition-colors text-center">Foro Iberoamericano</span>
              </div>

              {/* Separator 1 */}
              <div className="flex items-center justify-center">
                <div className="hidden md:flex flex-col items-center gap-2">
                  <div className="w-px h-12 bg-gradient-to-b from-transparent via-gray-400 to-transparent"></div>
                  <div className="bg-[#0077C8] p-2 rounded-full shadow-lg">
                    <Globe className="w-5 h-5 text-white" />
                  </div>
                  <div className="w-px h-12 bg-gradient-to-b from-gray-400 via-transparent to-transparent"></div>
                </div>
                <div className="md:hidden w-32 h-px bg-gradient-to-r from-transparent via-gray-400 to-transparent"></div>
              </div>

              {/* Logo UNESCO */}
              <div className="group flex flex-col items-center">
                <div className="bg-white rounded-xl p-6 shadow-md hover:shadow-xl transition-all duration-300 transform group-hover:scale-105 border-2 border-transparent hover:border-[#0077C8]/20">
                  <img 
                    src="http://catedra-unesco.cenid.org/images/unesco.png" 
                    alt="Logo UNESCO" 
                    className="h-24 md:h-32 w-auto object-contain"
                  />
                </div>
                <span className="mt-3 text-sm font-semibold text-gray-700 group-hover:text-[#0077C8] transition-colors text-center">UNESCO</span>
              </div>

              {/* Separator 2 */}
              <div className="flex items-center justify-center">
                <div className="hidden md:flex flex-col items-center gap-2">
                  <div className="w-px h-12 bg-gradient-to-b from-transparent via-gray-400 to-transparent"></div>
                  <div className="bg-[#0077C8] p-2 rounded-full shadow-lg">
                    <BookOpen className="w-5 h-5 text-white" />
                  </div>
                  <div className="w-px h-12 bg-gradient-to-b from-gray-400 via-transparent to-transparent"></div>
                </div>
                <div className="md:hidden w-32 h-px bg-gradient-to-r from-transparent via-gray-400 to-transparent"></div>
              </div>

              {/* Logo Proyecto Cátedra */}
              <div className="group flex flex-col items-center">
                <div className="bg-white rounded-xl p-6 shadow-md hover:shadow-xl transition-all duration-300 transform group-hover:scale-105 border-2 border-transparent hover:border-[#0077C8]/20">
                  <img 
                    src="https://recursos.cenid.org/img_cenid/proyecto_catedra.png" 
                    alt="Proyecto Cátedra" 
                    className="h-24 md:h-32 w-auto object-contain"
                  />
                </div>
                <span className="mt-3 text-sm font-semibold text-gray-700 group-hover:text-[#0077C8] transition-colors text-center">Proyecto Cátedra</span>
              </div>
            </div>
          </div>

          <div className="text-center">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6">
              Quiénes Somos
            </h1>
            <p className="text-xl md:text-2xl max-w-4xl mx-auto">
              Cátedra UNESCO CENID - Proyecto sobre análisis e inclusión del conocimiento
            </p>
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6 py-12">
        
        {/* Misión */}
        <section className="mb-16">
          <div className="bg-white rounded-lg shadow-xl overflow-hidden border-t-4 border-blue-600">
            <div className="p-8">
              <h2 className="text-4xl font-bold text-gray-900 mb-6 flex items-center gap-3">
                <Target className="w-10 h-10 text-blue-600" />
                Misión
              </h2>
              
              <div className="bg-gradient-to-r from-blue-50 to-indigo-50 p-8 rounded-lg border-l-4 border-blue-600">
                <p className="text-lg text-gray-700 leading-relaxed">
                  Promover la creación de conocimiento y la innovación reuniendo a la <strong>comunidad Iberoamericana de Cátedras UNESCO y Redes UNITWIN</strong>, investigadores, representantes de la sociedad civil, profesionales y especialistas en una plataforma abierta para el debate, la colaboración y el intercambio de conocimientos, con miras a <strong>ampliar la cooperación para abordar las cuestiones acuciantes de nuestro tiempo</strong>.
                </p>
              </div>

              <div className="mt-6 grid grid-cols-1 md:grid-cols-3 gap-4">
                <div className="bg-blue-50 p-5 rounded-lg text-center border border-blue-200">
                  <Network className="w-10 h-10 text-blue-600 mx-auto mb-3" />
                  <h3 className="font-bold text-gray-900 mb-2">Colaboración</h3>
                  <p className="text-sm text-gray-700">Plataforma abierta para el intercambio</p>
                </div>
                <div className="bg-blue-50 p-5 rounded-lg text-center border border-blue-200">
                  <Lightbulb className="w-10 h-10 text-[#0077C8] mx-auto mb-3" />
                  <h3 className="font-bold text-gray-900 mb-2">Innovación</h3>
                  <p className="text-sm text-gray-700">Creación de conocimiento nuevo</p>
                </div>
                <div className="bg-purple-50 p-5 rounded-lg text-center border border-purple-200">
                  <Globe className="w-10 h-10 text-purple-600 mx-auto mb-3" />
                  <h3 className="font-bold text-gray-900 mb-2">Cooperación</h3>
                  <p className="text-sm text-gray-700">Abordar retos globales</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Visión */}
        <section className="mb-16">
          <div className="bg-white rounded-lg shadow-xl overflow-hidden border-t-4 border-purple-600">
            <div className="p-8">
              <h2 className="text-4xl font-bold text-gray-900 mb-6 flex items-center gap-3">
                <Eye className="w-10 h-10 text-purple-600" />
                Visión
              </h2>
              
              <div className="space-y-6">
                <div className="bg-gradient-to-r from-purple-50 to-indigo-50 p-6 rounded-lg border-l-4 border-purple-600">
                  <p className="text-gray-700 leading-relaxed mb-4">
                    El proyecto busca participar en una <strong>sociedad orientada por el conocimiento</strong> fortalecido a través de la investigación y colaboración con otras organizaciones a nivel local, nacional e internacional. La misma se demuestra en dos puntos claves:
                  </p>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  {/* Punto 1 */}
                  <div className="bg-white border-2 border-purple-200 rounded-lg p-6 hover:shadow-lg transition-all">
                    <div className="flex items-start gap-3 mb-4">
                      <div className="bg-purple-600 text-white rounded-full w-10 h-10 flex items-center justify-center font-bold text-lg flex-shrink-0">
                        1
                      </div>
                      <h3 className="text-xl font-bold text-purple-900 mt-1">
                        Estimular y Promover
                      </h3>
                    </div>
                    <div className="ml-13">
                      <p className="text-gray-700 mb-3">
                        Estimular y Promover la creación de conocimiento y la innovación en los procesos de transformación de las instituciones de educación superior mediante:
                      </p>
                      <ul className="space-y-2 text-sm text-gray-700">
                        <li className="flex items-start gap-2">
                          <CheckCircle className="w-4 h-4 text-purple-600 flex-shrink-0 mt-0.5" />
                          <span>Proyectos interinstitucionales de colaboración</span>
                        </li>
                        <li className="flex items-start gap-2">
                          <CheckCircle className="w-4 h-4 text-purple-600 flex-shrink-0 mt-0.5" />
                          <span>Investigación conjunta de educación comparada</span>
                        </li>
                        <li className="flex items-start gap-2">
                          <CheckCircle className="w-4 h-4 text-purple-600 flex-shrink-0 mt-0.5" />
                          <span>Encuentros e intercambios con los países de Iberoamérica</span>
                        </li>
                        <li className="flex items-start gap-2">
                          <CheckCircle className="w-4 h-4 text-purple-600 flex-shrink-0 mt-0.5" />
                          <span>Relación en el ámbito internacional</span>
                        </li>
                      </ul>
                    </div>
                  </div>

                  {/* Punto 2 */}
                  <div className="bg-white border-2 border-blue-200 rounded-lg p-6 hover:shadow-lg transition-all">
                    <div className="flex items-start gap-3 mb-4">
                      <div className="bg-[#0077C8] text-white rounded-full w-10 h-10 flex items-center justify-center font-bold text-lg flex-shrink-0">
                        2
                      </div>
                      <h3 className="text-xl font-bold text-[#0077C8] mt-1">
                        Desarrollar la difusión
                      </h3>
                    </div>
                    <div className="ml-13">
                      <p className="text-gray-700 mb-3">
                        Desarrollar la difusión de conocimiento y el diálogo en la región mediante:
                      </p>
                      <ul className="space-y-2 text-sm text-gray-700">
                        <li className="flex items-start gap-2">
                          <CheckCircle className="w-4 h-4 text-indigo-600 flex-shrink-0 mt-0.5" />
                          <span>Organización de congresos, seminarios y simposios</span>
                        </li>
                        <li className="flex items-start gap-2">
                          <CheckCircle className="w-4 h-4 text-indigo-600 flex-shrink-0 mt-0.5" />
                          <span>Publicación de materiales especializados</span>
                        </li>
                        <li className="flex items-start gap-2">
                          <CheckCircle className="w-4 h-4 text-indigo-600 flex-shrink-0 mt-0.5" />
                          <span>Participación en foros internacionales sobre educación superior</span>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Objetivos */}
        <section className="mb-16">
          <div className="bg-white rounded-lg shadow-xl overflow-hidden border-t-4 border-green-600">
            <div className="p-8">
              <h2 className="text-4xl font-bold text-gray-900 mb-6 flex items-center gap-3">
                <TrendingUp className="w-10 h-10 text-green-600" />
                Objetivos
              </h2>
              
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {objetivos.map((objetivo, index) => {
                  const IconComponent = objetivo.icon;
                  return (
                    <div 
                      key={index}
                      className="bg-gradient-to-br from-white to-green-50 border-2 border-green-200 rounded-lg p-6 hover:shadow-lg transition-all"
                    >
                      <div className="flex items-start gap-4 mb-4">
                        <div className="bg-green-100 p-3 rounded-lg">
                          <IconComponent className="w-8 h-8 text-green-600" />
                        </div>
                        <h3 className="text-lg font-bold text-gray-900 flex-1">
                          {objetivo.titulo}
                        </h3>
                      </div>
                      <p className="text-gray-700 leading-relaxed">
                        {objetivo.descripcion}
                      </p>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </section>

        {/* Lineamientos de Acción */}
        <section className="mb-16">
          <div className="bg-white rounded-lg shadow-xl overflow-hidden border-t-4 border-orange-600">
            <div className="p-8">
              <h2 className="text-4xl font-bold text-gray-900 mb-6 flex items-center gap-3">
                <Award className="w-10 h-10 text-orange-600" />
                Lineamientos de acción
              </h2>
              
              <div className="space-y-6">
                {lineamientosAccion.map((lineamiento, index) => {
                  const IconComponent = lineamiento.icon;
                  return (
                    <div 
                      key={index}
                      className="bg-gradient-to-r from-orange-50 to-amber-50 border-l-4 border-orange-600 rounded-lg p-6 hover:shadow-lg transition-all"
                    >
                      <div className="flex items-start gap-4">
                        <div className="bg-orange-100 p-3 rounded-lg flex-shrink-0">
                          <IconComponent className="w-7 h-7 text-orange-600" />
                        </div>
                        <div className="flex-1">
                          <h3 className="text-xl font-bold text-gray-900 mb-3">
                            {lineamiento.titulo}
                          </h3>
                          <p className="text-gray-700 leading-relaxed">
                            {lineamiento.descripcion}
                          </p>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>

              <div className="mt-8 bg-gradient-to-r from-orange-100 to-red-100 border-2 border-orange-300 rounded-lg p-6">
                <div className="flex items-start gap-4">
                  <Lightbulb className="w-8 h-8 text-orange-600 flex-shrink-0" />
                  <div>
                    <h3 className="font-bold text-lg text-gray-900 mb-2">Objetivo final</h3>
                    <p className="text-gray-700 leading-relaxed">
                      Contribuir a la <strong>promoción y renovación del pensamiento crítico</strong>, buscando formar parte de grupos internacionales en torno a los saberes requeridos para su práctica social.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Call to Action */}
        <section>
          <div className="bg-gradient-to-r from-indigo-600 to-purple-600 text-white rounded-lg shadow-xl p-8 text-center">
            <Network className="w-16 h-16 mx-auto mb-4" />
            <h2 className="text-3xl font-bold mb-4">Únete a nuestra red</h2>
            <p className="text-xl text-indigo-100 mb-6 max-w-3xl mx-auto">
              Forma parte de la comunidad iberoamericana de Cátedras UNESCO comprometida con la transformación educativa y el desarrollo sostenible
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link 
                to="/catedra-unesco/proyectos"
                className="inline-flex items-center gap-2 bg-white text-[#0077C8] px-8 py-4 rounded-lg font-bold text-lg hover:shadow-xl transform hover:scale-105 transition-all"
              >
                <Target className="w-6 h-6" />
                Ver nuestros proyectos
              </Link>
              <Link 
                to="/catedra-unesco"
                className="inline-flex items-center gap-2 bg-white/20 text-white border-2 border-white px-8 py-4 rounded-lg font-bold text-lg hover:bg-white hover:text-[#0077C8] transition-all"
              >
                <ArrowRight className="w-6 h-6" />
                Volver al inicio
              </Link>
            </div>
          </div>
        </section>

      </div>
    </div>
  );
};

export default QuienesSomos;
